<template>
  <b-col
    cols="8"
    class="px-0"
  >
    <b-input-group>
      <CategoryRow
        v-for="(_, col) in fields"
        :key="`category-${row}-field-${col}`"
        :field.sync="fields[col]"
        :v="v.$each[col]"
        :chart-unit="chartUnit"
      />
    </b-input-group>
  </b-col>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import CategoryRow from '@/components/builder/ComparisonGraphSettings/CategoryRow.vue'

const components = {
  CategoryRow,
}

const props = {
  fields: {
    type: Array,
    required: true,
  },
  row: {
    type: Number,
    required: true,
  },
  v: {
    type: Object,
    required: true,
  },
  chartUnit: {
    type: String,
    required: true,
  },
}

@Component({ components })
export default class CategoryRows extends Vue.extend({ props }) {}

</script>
